import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import './Preview.css';
import Button from '../primitives/Button/Button';
import MediaSettings from '../MediaSettings/MediaSettings';
import { useDaily } from '@daily-co/daily-react';
import UserMediaService from '../../../services/UserMediaService';
import { useCallLocalMedia, CallLocalMediaContextValue } from '../context/CallLocalMediaContext';
import HeaderWithBack from '../primitives/HeaderWithBack/HeaderWithBack';

interface PreviewProps {
  onEnter: () => void;
}

const Preview: React.FC<PreviewProps> = ({ onEnter }) => {
  const callObject = useDaily();
  const isEnteringWorld = useRef<boolean>(false);
  const { handleEnableMic, handleEnableCamera } = useCallLocalMedia() as CallLocalMediaContextValue;


  useEffect(() => {
    return () => {
      if (!isEnteringWorld.current) UserMediaService.stopMediaTracks();
    }
  }, []);

  const enterRoom = useCallback(() => {
    isEnteringWorld.current = true;
    callObject?.join();
    onEnter();
  }, [onEnter]);

  const handleUserNameChange = useCallback((userName: string) => {
    callObject?.setUserName(userName);
  }, [callObject]);

  const handleShouldEnableMic = useCallback((isEnabled: boolean) => {
    handleEnableMic(isEnabled);
  }, [handleEnableMic]);

  const handleShouldEnableCamera = useCallback((isEnabled: boolean) => {
    handleEnableCamera(isEnabled);
  }, [handleEnableCamera]);

  const handleSelectedMicIdChange = useCallback((selectedDeviceId: string) => {
    callObject?.setInputDevicesAsync({ audioDeviceId: selectedDeviceId });
  }, [callObject]);

  const handleSelectedCameraIdChange = useCallback((selectedDeviceId: string) => {
    callObject?.setInputDevicesAsync({ videoDeviceId: selectedDeviceId });
  }, [callObject]);

  const enterRoomButton = useMemo(() => (
    <Button onClick={enterRoom} label='Enter' />
  ), [enterRoom])

  const headerWithBackElement = useMemo(() => (
    <HeaderWithBack title={'Preview'} />
  ), [])

  return (
    <div className="preview-modal">
      <div className="preview-content">
        <div className='root-preview'>
          { headerWithBackElement }
          <MediaSettings
            onShouldEnableMic={handleShouldEnableMic}
            onShouldEnableCamera={handleShouldEnableCamera}
            onSelectedMicIdChange={handleSelectedMicIdChange}
            onSelectedCameraIdChange={handleSelectedCameraIdChange}
            onUserNameChange={handleUserNameChange}
          />
          <div className='button-container'>
            { enterRoomButton }
          </div>
        </div>
      </div>
      <div className="translucent-mask"></div>
    </div>
  );
};

export default Preview;
